import {LineupsMemberYardFormationDomainModel} from "./yard-formation/lineups-member-yard-formation-domain-model";
import {FormationPositionDomainModel} from "../../formation/formation-position.domain-model";
import {PositionDomainModel} from "../../position/position.domain-model";
import {LineupsMemberInjuryDomainModel} from "./injury/lineups-member-injury-domain-model";
import {LineupsMemberSuspensionDomainModel} from "./suspension/lineups-member-suspension-domain-model";
import {LineupsMemberApiModel} from "./lineups-member-api-model";
import {EventDomainModel} from "../../../common/events/models/event-domain-model";
import {LineupsMemberSeasonStatsDomainModel} from "./season-stats/lineups-member.season-stats.domain-model";
import {LineupsMemberStatsDomainModel} from "./stats/lineups-member.stats.domain-model";
import {LineupsMemberStatsApiModel} from "./stats/lineups-member.stats.api-model";
import {MemberDomainModel} from "../../member/member-domain-model";
import {MemberApiModel} from "../../member/member-api-model";
import {SportDomainModel} from "../../../sports/models/sport-domain-model";
import {CompetitorDomainModel} from "../../../common/competitor/models/competitor-domain-model";
import {computed} from "mobx";
import {SPORT_TYPES} from "../../../../core/app/consts";

export class LineupsMemberDomainModel extends MemberDomainModel {
  apiModel: MemberApiModel;
  lineupsMemberApiModel: LineupsMemberApiModel;
  position: PositionDomainModel = null;
  formation: FormationPositionDomainModel = null;
  yardFormation: LineupsMemberYardFormationDomainModel = null;
  injury: LineupsMemberInjuryDomainModel = null;
  suspension: LineupsMemberSuspensionDomainModel = null;
  seasonStats: Array<LineupsMemberSeasonStatsDomainModel> = null;
  events: Array<EventDomainModel> = [];
  competitorNum: Number;
  competitor: CompetitorDomainModel;

  constructor(
    memberApiModel: MemberApiModel,
    lineupsMemberApiModel: LineupsMemberApiModel,
    isNational: Boolean,
    position: PositionDomainModel,
    formation: FormationPositionDomainModel,
    yardFormation: LineupsMemberYardFormationDomainModel,
    injury: LineupsMemberInjuryDomainModel,
    suspension: LineupsMemberSuspensionDomainModel,
    seasonStats: Array<LineupsMemberSeasonStatsDomainModel>,
    stats: Array<LineupsMemberStatsDomainModel>,
    events: Array<EventDomainModel> = [],
    sport: SportDomainModel,
    competitorNum: Number,
    competitor: CompetitorDomainModel = null
  ) {
    super(memberApiModel, isNational, sport);

    this.lineupsMemberApiModel = lineupsMemberApiModel;
    this.position = position;
    this.formation = formation;
    this.yardFormation = yardFormation;
    this.injury = injury;
    this.suspension = suspension;
    this.seasonStats = seasonStats;
    this.competitorNum = competitorNum;
    this.competitor = competitor;

    this.events.push(...events);
  }

  get didNotPlayed(): Boolean {
    return this.lineupsMemberApiModel.didNotPlayed;
  }

  get didNotPlayedReason(): String {
    return this.lineupsMemberApiModel.didNotPlayedReason;
  }

  get status(): Number {
    return this.lineupsMemberApiModel.status;
  }

  get statusText(): String {
    return this.lineupsMemberApiModel.statusText;
  }

  get ranking(): Number {
    return this.lineupsMemberApiModel.ranking;
  }

  get hasHighestRanking(): Boolean {
    return this.lineupsMemberApiModel.hasHighestRanking;
  }

  get hasStats(): Boolean {
    return this.lineupsMemberApiModel.hasStats;
  }

  get heatMap(): Boolean {
    return this.lineupsMemberApiModel.heatMap;
  }

  get stats(): Boolean {
    const stats: LineupsMemberStatsDomainModel = this.lineupsMemberApiModel.stats?.map((stat: LineupsMemberStatsApiModel) => new LineupsMemberStatsDomainModel(stat));

    return stats;
  }

  get fouledOut(): Boolean {
    return this.lineupsMemberApiModel.fouledOut;
  }

  get gameId(): Boolean {
    return this.lineupsMemberApiModel.gameId;
  }

  get nationalId(): Boolean {
    return this.lineupsMemberApiModel.nationalId;
  }

  @computed get isDoubtful(): Boolean {
    return this.sport?.id === SPORT_TYPES.football && this.lineupsMemberApiModel.isDoubtful;
  }
}